import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
import indexRouter from './modules/index';
import projectRouter from './modules/project';
import aboutRouter from './modules/about';

export const constantRoutes = [
    indexRouter,
    projectRouter,
    aboutRouter
];

const createRouter = () => new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: constantRoutes
});
const router = createRouter();

router.beforeEach((to, from, next)=>{
    next();
})

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router;